export const SOUNDS = {
  DEFAULT: "/assets/audio/ding.mp3",
  SUCCESS: "/assets/audio/success.mp3",
  ERROR: "/assets/audio/error.mp3",
  NOTIFICATION: "/assets/audio/notification.mp3",
};

export const DEFAULT_SOUND = SOUNDS.DEFAULT;